// src/slices/cartSlice.js
import { createSlice } from '@reduxjs/toolkit';

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    items: [],
    itemToEdit: null,
  },
  reducers: {
    addToCart(state, action) {
      state.items.push(action.payload);
    },
    removeFromCart(state, action) {
      state.items = state.items.filter((item, index) => index !== action.payload);
    },
    setItemToEdit(state, action) {
      state.itemToEdit = action.payload;
    },
    clearItemToEdit(state) {
      state.itemToEdit = null;
    },
    updateCartItem(state, action) {
      const { index, newItem } = action.payload;
      state.items[index] = newItem;
    },
    clearCart(state) {
      state.items = [];   // ✅ empty cart
      state.itemToEdit = null;
    },
  },
});

export const {
  addToCart,
  removeFromCart,
  setItemToEdit,
  clearItemToEdit,
  updateCartItem,
  clearCart,   // ✅ export it
} = cartSlice.actions;

export default cartSlice.reducer;
